import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoginAuthenticationScreenExtendedComponent } from './login-authentication-screen-extended.component';
import {
  AnalyticsData,
  LoginAuthUserInputFields,
  LoginContent
} from './models/login-credentials.interface';
@Component({
  selector: 'idp-login-authentication-screen',
  templateUrl: './login-authentication-screen.component.html',
  styleUrls: ['./login-authentication-screen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginAuthenticationScreenComponent
  extends LoginAuthenticationScreenExtendedComponent
  implements OnInit, OnChanges
{
  @ViewChild('formAlert', { read: ElementRef }) formAlert!: ElementRef;
  @Output() formSubmitEvent: EventEmitter<LoginAuthUserInputFields> =
    new EventEmitter<LoginAuthUserInputFields>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() footerLinkClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() forgotPasswordWithUserId: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() logOut = new EventEmitter();
  @Input() toggleModalCallback!: () => void;
  @Input() recognitionPage!: boolean;
  @Input() ccrLoggedoutState = false;
  @Input() errorAdobeTracker = false;
  @Input() successAdobeTracker = false;
  @Input() checkOutWarmState = false;
  @Input() content: LoginContent | null | undefined = {} as LoginContent;
  form!: UntypedFormGroup | undefined;
  @Output() isLastNameEnabled = new EventEmitter<boolean>();
  @Output() formAlertDisplay: EventEmitter<void> = new EventEmitter<void>();
  ngOnInit(): void {
    this.trackPageLoad();
    this.form = this.content?.formGroup;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.checkSkyMilesNumber(changes)) {
      this.content.formGroup.patchValue({
        userId: {
          value: changes.content.currentValue.skyMilesNumber,
          id: 'userId'
        }
      });
      this.content.formGroup.patchValue({
        keepMeLoggedIn: { value: true }
      });
      this.content.formGroup.controls['userId'].disable();
    }
  }

  public get showErrorMessageuserId(): boolean {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('userId')
    );
    return (
      control &&
      this.content?.loginFormAttributes?.userIdControlTouched &&
      control?.invalid
    );
  }

  public get showErrorMessagePassword(): boolean {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('password')
    );
    return (
      control &&
      this.content?.loginFormAttributes.passwordControlTouched &&
      control.invalid
    );
  }

  public get showErrorMessageLastName(): boolean {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('lastName')
    );
    return (
      control &&
      this.content?.loginFormAttributes.lastNameControlTouched &&
      control.invalid
    );
  }

  firstInvalidFieldFocusEvent(): void {
    this.focusInvalidField.emit();
  }

  submit(): void {
    const userInputFields: LoginAuthUserInputFields = {
      userName: this.content?.formGroup.get('userId')?.value?.value,
      password: this.content?.formGroup.get('password')?.value?.value,
      lastName: this.content?.formGroup.get('lastName')?.value?.value,
      persistentLogin: this.content?.formGroup.get('keepMeLoggedIn')?.value
        ?.value
        ? 'Y'
        : 'N'
    };
    this.redirectTrackingClick.emit({ action: 'login' });
    this.formSubmitEvent.emit(userInputFields);
  }

  onFocussedOut(fieldName: string): void {
    this.fieldFocusOut.emit(fieldName);
  }

  onChange(): void {
    this.isLastNameEnabled.emit(
      this.content?.loginFormAttributes?.isLastNameRequired
    );
    this.inputChange.emit();
  }

  onClosePop(): void {
    this.formAlertDisplay.emit();
  }

  onFooterLinkClick(viewName: string): void {
    this.footerLinkClick.emit(viewName);
  }

  onForgotPasswordClick(userId: string): void {
    this.forgotPasswordWithUserId.emit(userId);
  }
}
